import React, { PureComponent } from 'react';
import { stringToBoolean } from '../../../utilities/conversionUtility';
import QuantityComponent from '../../../components/Common/QuantityComponent';

export default class QuantityInput extends PureComponent {
  constructor(props) {
    super(props);

    this.onClickPrevButton = this.onClickPrevButton.bind(this);
    this.onClickNextButton = this.onClickNextButton.bind(this);
  }

  componentDidMount() {
    const { bookingToken } = this.props;
    if (!bookingToken) {
      this.onQuantityChange(1);
    }
  }

  componentDidUpdate(prevProps) {
    const { setting: prevSetting, maxQuantity: prevMaxQuantity } = prevProps;
    const {
      bookingToken,
      quantity,
      setting: {
        minimum_quantity: minimumQuantity,
        set_minimum_quantity: setMinimumQuantity,
      },
    } = this.props;
    const maxQuantity = this.maxQuantity();

    if (bookingToken) {
      return;
    }

    if (stringToBoolean(setMinimumQuantity) && (
      stringToBoolean(setMinimumQuantity) !== stringToBoolean(prevSetting.set_minimum_quantity)
      || minimumQuantity !== prevSetting.minimum_quantity
    )) {
      const newQuantity = Number(minimumQuantity);
      if (newQuantity > quantity) {
        this.onQuantityChange(newQuantity);
      }
    } else if (maxQuantity !== prevMaxQuantity) {
      this.onQuantityChange(quantity);
    } else if (maxQuantity < quantity) {
      this.onQuantityChange(maxQuantity);
    }
  }

  componentWillUnmount() {
    const { onSetOrderDetails } = this.props;
    onSetOrderDetails({ quantity: 1, totalQuantity: this.getMultiplier() });
  }

  getMultiplier() {
    const { variants, variantSelected } = this.props;
    const selectedVariant = variantSelected ? variants.find((v) => v.external_id === variantSelected) : {};
    return selectedVariant ? selectedVariant.unit_multiplier : 1;
  }

  getPrice() {
    const { variants, variantSelected } = this.props;
    const selectedVariant = variantSelected ? variants.find((v) => v.external_id === variantSelected) : {};
    return selectedVariant ? selectedVariant.price : 0;
  }

  maxQuantity() {
    const { maxQuantity } = this.props;
    if (!Number.isInteger(maxQuantity)) {
      return null;
    }
    const quantity = parseInt((maxQuantity || 1) / this.getMultiplier(), 10);
    return quantity < 1 ? 1 : quantity;
  }

  onClickNextButton() {
    const { quantity = 1 } = this.props;
    const nextValue = quantity + 1;
    this.onQuantityChange(nextValue);
  }

  onClickPrevButton() {
    const { min = 0, quantity = 1 } = this.props;
    const prevValue = quantity - 1 > min ? quantity - 1 : min;
    this.onQuantityChange(prevValue);
  }

  onQuantityChange(value) {
    const {
      onSetOrderDetails,
      setting: {
        minimum_quantity: minimumQuantity,
        set_minimum_quantity: setMinimumQuantity,
        show_quantity_chooser: showQuantityChooser,
      },
    } = this.props;
    const maxQuantity = this.maxQuantity();
    const minQuantity = Number(minimumQuantity) || 1;
    let newQuantity = value;

    if (
      stringToBoolean(showQuantityChooser)
      && stringToBoolean(setMinimumQuantity)
      && (newQuantity < minQuantity)
    ) {
      newQuantity = minQuantity;
    }

    if (maxQuantity && newQuantity > maxQuantity) {
      newQuantity = maxQuantity;
    }

    onSetOrderDetails({
      quantity: newQuantity,
      totalQuantity: newQuantity * this.getMultiplier(),
      totalPrice: newQuantity * this.getPrice(),
    });
  }

  render() {
    const { bookingToken } = this.props;
    if (bookingToken) {
      return null;
    }

    const {
      quantity = 1,
      label,
      style,
      min = 0,
      setting: {
        minimum_quantity: minimumQuantity,
        show_quantity_chooser: showQuantityChooser,
        set_minimum_quantity: setMinimumQuantity,
      },
    } = this.props;
    const minQuantity = (
      stringToBoolean(setMinimumQuantity) && stringToBoolean(showQuantityChooser) && Number(minimumQuantity)
    ) || min;

    return (
      <QuantityComponent
        label={label}
        maxQuantity={this.maxQuantity()}
        minQuantity={minQuantity}
        onClickNextButton={this.onClickNextButton}
        onClickPrevButton={this.onClickPrevButton}
        style={style}
        quantity={quantity}
        width="96%"
      />
    );
  }
}
